export default "__VITE_ASSET__C4qoEnXL__"